import {InteractionEvent} from 'pixi.js';
import {InteractionEventTypes} from '@inlet/react-pixi';

export type InteractionEvents = {
    [P in InteractionEventTypes]?: (event: InteractionEvent) => void;
};

export type InteractionDisplayObject = InteractionEvents & {
    interactive?: boolean;
    buttonMode?: boolean;
};